import { createContext, useContext } from 'react'
import { UISettings } from '../../dme.types'

const LayoutContext = createContext<UISettings | null>(null)
export const LayoutContextProvider = LayoutContext.Provider

export function useLayout() {
  return useContext(LayoutContext)
}
